'use strict';

require('core/rxForm/rxFormExpiration');
